__turbopack_context__.v({
  "button": "step-email-module-scss-module__Vx4tyq__button",
  "footer_description": "step-email-module-scss-module__Vx4tyq__footer_description",
});
